import {
  genericCreate,
} from '@/services/common';

export const create = genericCreate('price');

export * from './types';

export default {
  create,
};
